import "./VehiclesFiltersFooter.scss";

import { useApplyFilters } from "../../../../../hooks/useApplyFilters";

import { Button } from "../../../../../common-components/Buttons/Buttons";

const VehiclesFiltersFooter = () => {
    const componentId = "vehicles";
    const { applyFiltersParams } = useApplyFilters({componentId})

    return (
        <div className={"vehicles-filters-footer"}>
            <div className={"vehicles-filters-footer_container"}>
                <div className={"vehicles-filters-footer_buttons"}>
                    <Button title={"Применить"} onClick={applyFiltersParams}/>
                </div>
            </div>
        </div>
    )
}

export default VehiclesFiltersFooter;